import React from 'react';
import ReactPaginate from 'react-paginate';


function CommonPagination({ handlePageClick, forcePage, pageCount, nextPage }) {
    return (
        <div className='cstm_pagination'>
            <ReactPaginate
                forcePage={forcePage}
                pageClassName="page-item"
                pageLinkClassName="page-link"
                previousClassName="page-item"
                previousLinkClassName="page-link"
                nextClassName="page-item"
                nextLinkClassName="page-link"
                breakClassName="page-item"
                breakLinkClassName="page-link"
                containerClassName="pagination"
                activeClassName="active"
                breakLabel="..."
                nextLabel={"Next >"}
                onPageChange={handlePageClick}
                pageRangeDisplayed={5}
                marginPagesDisplayed={2}
                pageCount={pageCount}
                previousLabel="< Previous"
            />
        </div>
    )
}

export default CommonPagination;